export default __webpack_public_path__ + "static/media/arma.46c13ead.jpg";